import { z } from 'zod';
import { CostRange } from '@/pages/Fleet/Drivers/models';

export const setDriverSchema = z.object({
  driverId: z.string().uuid('ID de conductor inválido'),
  value_amount: z.preprocess(
    (a) => Number(a),
    z.number().min(1, 'El valor debe ser mayor a 0')
  ),
});

export const quickCreateDriverSchema = z.object({
  name: z
    .string()
    .min(2, 'Mínimo 2 caracteres')
    .max(25, 'Máximo 25 caracteres'),
  lastName: z
    .string()
    .min(2, 'Mínimo 2 caracteres')
    .max(25, 'Máximo 25 caracteres'),
  phone: z.string().min(9, 'Mínimo 9 dígitos').max(11, 'Máximo 11 dígitos'),
});

export const quickCostSchema = z.object({
  costModeId: z.string().min(1),
  from: z.string().min(1),
  to: z.string().min(1),
});

export type SetDriverSchema = z.infer<typeof setDriverSchema>;
export type QuickCreateDriverSchema = z.infer<typeof quickCreateDriverSchema>;
export type QuickCostSchema = z.infer<typeof quickCostSchema>;

export interface SelectedDriver {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  Schedules?: Array<{
    id: string;
    from: string | Date;
    to: string | Date;
    costMode?: {
      name: string;
      Costs?: Array<{ amount: number }>;
    };
  }>;
}

export interface CostInfo {
  amount: number | null;
  mode: string | null;
}

export interface QuickCreateFormProps {
  onCreateDriver: (
    name: string,
    lastName: string,
    phone: string
  ) => Promise<void>;
  onCancel: () => void;
  isCreating: boolean;
}

export interface DriverInfoProps {
  driver: SelectedDriver;
  costInfo: CostInfo;
}

export interface SetDriverFormProps {
  assignmentId: string;
  valueAmount: number;
  startTime?: Date;
  onClose: () => void;
}

export interface QuickCreateDriverPayload {
  name: string;
  lastName: string;
  phone: string;
  email: string;
  costRange: CostRange;
  companyId: string;
}

export interface QuickCostModeFormProps {
  driver: SelectedDriver;
  onSuccess: (driverId: string) => void;
  onCancel: () => void;
}
